<div class="set-element-size">
  <div *ngIf="loading$ | async">
    <app-loading-indicator></app-loading-indicator>
  </div>
  <div class="row">
    <img class="set-image-size" *ngIf="qrCode" [src]="qrCode" width="40%" height="40%" alt="qrcode" />
  </div>
  <div class="row">
    <form [formGroup]="mfaForm" autocomplete="off">
      <label class="input-container__label">
        MFA Code
        <input
          id="totp.code"
          type="text"
          class="input-container__field"
          formControlName="totpCode">
      </label>
    </form>
    <br>
  </div>
  <div class="row margin-bottom">
    <div class="input-container--lg">
      <p>Scan the QR Code into the authenticator application of your choice and enter the 6 digit code for
        verification.</p>
      <br>
      <div *ngIf="showSecret">
        <p>Secret: <span class="secret-code">{{ mfaForm.get('secret').value }}</span></p>
      </div>
      <a id="mfa.toggleSecret" (click)="onToggleSecret()">{{ showSecret ? 'Hide Secret' : 'Show Secret' }}</a>
      <br>
    </div>
  </div>
  <div class="row row--space-between">
      <div>
        <button
          id="totp.regenBtn"
          type="button"
          class="btn btn--secondary-outline"
          (click)="onRegenerateTotp()">
          Regenerate
        </button>
      </div>
      <div>
        <div class="row row--end">
          <button
            id="mfa.cancelBtn"
            class="btn btn--tertiary"
            (click)="onCloseMfa()">
            Cancel
          </button>
          <button
            id="mfa.submitBtn"
            class="btn btn--primary"
            [ngClass]="{'disabled': !mfaForm.valid}"
            [disabled]="mfaForm.invalid"
            (click)="onSubmitTotp()">
            Submit
          </button>
        </div>
      </div>
    </div>
</div>

